@layer design-system {
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  .spinner {
    border-style: solid;
    border-color: var(--icon-default) transparent var(--icon-default)
      var(--icon-default);
    border-radius: 50%;
    position: relative;
    animation: rotate 1s linear infinite;

    &::before,
    &::after {
      content: '';
      border-radius: 50%;
      background: var(--icon-default);
      position: absolute;
    }

    &.accent {
      border-color: var(--icon-primary) transparent var(--icon-primary)
        var(--icon-primary);

      &::before,
      &::after {
        background: var(--icon-primary);
      }
    }

    &.extraSmall {
      border-width: 2px;
      width: 12px;
      height: 12px;

      &::before,
      &::after {
        width: 2px;
        height: 2px;
      }

      &::before {
        top: -1px;
        right: 0;
      }

      &::after {
        bottom: -1px;
        right: 0;
      }
    }

    &.small {
      border-width: 3px;
      width: 16px;
      height: 16px;

      &::before,
      &::after {
        width: 3px;
        height: 3px;
      }

      &::before {
        top: -1px;
        right: -1px;
      }

      &::after {
        bottom: -1px;
        right: -1px;
      }
    }

    &.large {
      border-width: 4px;
      width: 40px;
      height: 40px;

      &::before,
      &::after {
        width: 4px;
        height: 4px;
      }

      &::before {
        top: 2px;
        right: 1px;
      }

      &::after {
        bottom: 2px;
        right: 1px;
      }
    }
  }
}
